import { JSX } from "react";

import { GridProps } from "@mui/material/Grid";

import { InternalClasses } from "../helpers";
import { DashboardIconProps } from "../Icon/DashboardIcon";

import { IconElement } from "@/icons/types";

type BaseSelectBarClasses = "container" | "containerSelected" | "icon" | "clickable" | "importVariant" | "disabled";

const PREFIX = "ZeffySelectBar";

export const zeffySelectBarClasses: InternalClasses<typeof PREFIX, BaseSelectBarClasses> = {
  container: `${PREFIX}-container`,
  containerSelected: `${PREFIX}-containerSelected`,
  icon: `${PREFIX}-icon`,
  clickable: `${PREFIX}-clickable`,
  importVariant: `${PREFIX}-importVariant`,
  disabled: `${PREFIX}-disabled`,
};

export interface SelectBarAction {
  label: string;
  onClick: () => void;
  icon: JSX.Element;
}

export interface SelectBarProps {
  title: React.ReactNode | string;
  description: React.ReactNode | string;
  onClick?: () => void;
  icon?: IconElement;
  iconProps?: Partial<Omit<DashboardIconProps, "ref" | "children">>;
  renderIcon?: JSX.Element;
  selected?: boolean;
  action?: SelectBarAction;
  hideArrow?: boolean;
  sx?: GridProps["sx"];
  displayDotSelect?: boolean;
  illustration?: string | IconElement;
  variant?: "default" | "import";
  disabled?: boolean;
  "data-test"?: string;
}
